import { Component, Input } from '@angular/core';

@Component({
  selector: 'mandae-integration-setup-watch-video',
  templateUrl: './integration-setup-watch-video.component.html',
  styleUrls: ['./integration-setup-watch-video.component.scss', '../integration-setup-dialog.shared.scss']
})
export class IntegrationSetupWatchVideoComponent {

  @Input() videoURL = '';
  @Input() stepCount = 0;
  @Input() stepNumber = 0;

}
